import { Transition, motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";

export function AnimateHeight({
  children,
  transition = { duration: 0.3 },
}: {
  children: React.ReactNode;
  transition?: Transition;
}) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [height, setHeight] = useState<number | "auto">("auto");
  const childCount = React.Children.count(children);
  const hasChildren = childCount > 0 && children != null;

  useEffect(() => {
    if (containerRef.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        // We only have one entry, so we can use entries[0].
        const observedHeight = entries[0].contentRect.height;
        setHeight(observedHeight);
      });

      resizeObserver.observe(containerRef.current);

      return () => {
        // Cleanup the observer when the component is unmounted
        resizeObserver.disconnect();
      };
    }
  }, []);

  return (
    <motion.div
      style={{ height, overflow: "hidden" }}
      animate={{ height }}
      transition={transition}
    >
      <div ref={containerRef}>{children}</div>
    </motion.div>
  );
}
